import MigrationItemViewDTO from '@src/adapters/dto/migration/MigrationItemViewDTO';
import useApi, { ApiOptions } from '../base/useApi';
import MigrationSuggestionDTO from '@src/adapters/dto/migration/MigrationSuggestionDTO';

interface Params {
  migrationId: string;
}

interface Result {
  items: MigrationItemViewDTO[];
  suggestions: MigrationSuggestionDTO[];
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/create_items_from_suggestions',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useCreateMigrationItemsFromSuggestions = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useCreateMigrationItemsFromSuggestionsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useCreateMigrationItemsFromSuggestions;
